var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgVerificationIcon = function SvgVerificationIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 7.46574V3.88788C2.80078 3.75849 2.85218 3.63439 2.94368 3.54289C3.03518 3.4514 3.15927 3.39999 3.28867 3.39999H13.0465C13.1759 3.39999 13.3 3.4514 13.3915 3.54289C13.483 3.63439 13.5344 3.75849 13.5344 3.88788V7.46574C13.5344 12.5895 9.18567 14.2871 8.31736 14.5749C8.22029 14.6083 8.11484 14.6083 8.01777 14.5749C7.14946 14.2871 2.80078 12.5895 2.80078 7.46574Z",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8023 7L7.86899 9.8L6.40234 8.4",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgVerificationIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuODAwNzggNy40NjU3NFYzLjg4Nzg4QzIuODAwNzggMy43NTg0OSAyLjg1MjE4IDMuNjM0MzkgMi45NDM2OCAzLjU0Mjg5QzMuMDM1MTggMy40NTE0IDMuMTU5MjcgMy4zOTk5OSAzLjI4ODY3IDMuMzk5OTlIMTMuMDQ2NUMxMy4xNzU5IDMuMzk5OTkgMTMuMyAzLjQ1MTQgMTMuMzkxNSAzLjU0Mjg5QzEzLjQ4MyAzLjYzNDM5IDEzLjUzNDQgMy43NTg0OSAxMy41MzQ0IDMuODg3ODhWNy40NjU3NEMxMy41MzQ0IDEyLjU4OTUgOS4xODU2NyAxNC4yODcxIDguMzE3MzYgMTQuNTc0OUM4LjIyMDI5IDE0LjYwODMgOC4xMTQ4NCAxNC42MDgzIDguMDE3NzcgMTQuNTc0OUM3LjE0OTQ2IDE0LjI4NzEgMi44MDA3OCAxMi41ODk1IDIuODAwNzggNy40NjU3NFoiIHN0cm9rZT0iIzA1NEJDNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuODAyMyA3TDcuODY4OTkgOS44TDYuNDAyMzQgOC40IiBzdHJva2U9IiMwNTRCQzciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";